import propsToAriaRole from "./propsToAriaRole.mjs";
const roleComponents = {
    article: "article",
    banner: "header",
    blockquote: "blockquote",
    code: "code",
    complementary: "aside",
    contentinfo: "footer",
    deletion: "del",
    emphasis: "em",
    figure: "figure",
    insertion: "ins",
    form: "form",
    list: "ul",
    listitem: "li",
    main: "main",
    navigation: "nav",
    region: "section",
    strong: "strong"
  },
  emptyObject = {},
  propsToAccessibilityComponent = (props = emptyObject) => {
    if (props.accessibilityRole === "label") return "label";
    const role = propsToAriaRole(props);
    if (role) {
      if (role === "heading") {
        const level = props.accessibilityLevel || props["aria-level"];
        return level != null ? `h${level}` : "h1";
      }
      return roleComponents[role];
    }
  };
var propsToAccessibilityComponent_default = propsToAccessibilityComponent;
export { propsToAccessibilityComponent_default as default };
//# sourceMappingURL=propsToAccessibilityComponent.mjs.map
